export const faqData = [
  {
    title: 'General',
    content: [
      {
        id: 1,
        title: 'What is a hackathon? Would I actually be hacking?',
        type: 'text',
        content: `A hackathon is an event where participants come up with creative solutions for pertinent problems in our society in a short amount of time. With such a short amount of time allocated to bring an idea to fruition, certain techniques are applied to produce something fast. We call this hacking.`,
      },
      {
        id: 2,
        title: 'What is the expected submission?',
        type: 'text',
        content: `Within the two-day period of What The Hack, you are not expected to have a fully polished solution. A functioning prototype is expected, as well as an idea of how the complete product would function. Hardware, software or a combination of both are all accepted.`,
      },
      {
        id: 3,
        title: 'Is this a physical or online hackathon?',
        type: 'text',
        content:
          'WTH 2022 returns in-person on the SUTD campus! All participants are required to be on-site for the set duration of the hackathon. ',
      },
      {
        id: 4,
        title: 'Which platforms will be used for this hackathon?',
        type: 'text',
        content:
          'Announcements will be made on a Telegram channel. Keep a lookout for an email from us closer to the event for the link. Submissions will be uploaded to Devpost.',
      },
      {
        id: 5,
        title: 'Are we allowed to continue hacking after hacking spaces close on Day 1?',
        type: 'text',
        content:
          'Yes. Participants have to leave the hacking spaces at 10pm on day 1, but you can still continue hacking.',
      },
      {
        id: 6,
        type: 'text',
        title: 'Will there be swag?',
        content: 'Of course! Swag will be distributed during the hackathon.',
      },
    ],
  },
  {
    title: 'Sign Up Eligibility',
    content: [
      {
        id: 7,
        title: 'Who is eligible to participate?',
        type: 'text',
        content: `All students aged 13 and above (as of 19th Dec 2022) registered at an educational institution in Singapore can participate. Students waiting for entry into university, including Full-Time National Servicemen (NSFs) are also eligible to participate. `,
      },
      {
        id: 8,
        title: 'Do I need to sign up with a team?',
        type: 'text',
        content: `It is recommended you form a team prior to signing up. However, you can sign up without a team and form teams at the start of the hackathon.`,
      },
      {
        id: 9,
        title: 'How would I know if my registration is confirmed?',
        type: 'text',
        content:
          'An email with more information will be sent to you after you submit the online signup form. If you do not receive the email within 3 days of signing up, do contact us. ',
      },
      {
        id: 10,
        type: 'text',
        title: 'Do I need to have any background in Computer Science / Hacking?',
        content:
          'You do not need a background in either, although knowing some basic coding will help a lot. Just come with an open mind to learn and try new things! ',
      },
      {
        id: 1.1,
        title: 'Do all members of the team need to be from the same school?',
        type: 'text',
        content: 'No, teams can be made up of members from different institutions.',
      },
    ],
  },
  {
    title: 'Registration',
    content: [
      {
        id: 11,
        title: 'When is the registration deadline?',
        type: 'text',
        content: `We will close registration when we hit the maximum capacity allowable for the hackathon or by 4th December 2359hrs, depending on whichever one is earlier.`,
      },
      {
        id: 12,
        title: 'Is this hackathon free?',
        type: 'text',
        content: `Yes, this hackathon is completely free. Join us and have fun, 
          you never know what your ideas might turn into!`,
      },
    ],
  },
  {
    title: 'Resources',
    content: [
      {
        id: 17,
        title: 'What resources will I get when I join What the Hack?',
        type: 'text',
        content:
          'All teams will be receiving a Hackpack each, as well as access to a Makerspace, which has various tools that help you to make your ideas into reality. We will also be announcing 1 more benefit from a sponsor soon!',
      },
      {
        id: 18,
        title: 'How do I access the Makerspace?',
        type: 'text',
        content:
          'Participants who wish to access the Makerspace will be required to sign an indemnity form at the Fab Lab before access is granted.',
      },
      {
        id: 19,
        title: 'What is inside the Hackpack?',
        type: 'text',
        content: `Each hackpack contains an Arduino Uno, Breadboard, RFID module, 16x2 Character LCD, 4 digit LED 7-segment display, Joystick, 4x4 Keyboard, Relay, Stepper Motor, Infrared Remote and Receiver, Temperature Sensor, as well as other passive components. All of these components will also come with a case.`,
      },
      {
        id: 20,
        title: 'What equipment will be available in the Makerspace?',
        type: 'text',
        content: `In addition to the Hacking Spaces that you will be provided to work on your ideas, you will have access to a Makerspace, which is provided by SUTD’s fabrication Lab. Learn how to use a 3D printer and Laser Cutters, as well as woodworking equipment such as belt sanders, bandsaws, and drill presses. There will also be an electronics lab available, with access to solder and electronic components. Our student helpers will be glad to assist you if you are not familiar with the equipment.`,
      },
    ],
  },
  {
    title: 'Others',
    content: [
      {
        id: 14,
        title: 'Can I build my prototype beforehand?',
        type: 'text',
        content: `No, you may only begin working (coding, building, analysing) on your prototype after we announce the start of the hacking period.`,
      },
      {
        id: 15,
        title: 'Do we get to pitch our idea?',
        type: 'text',
        content: `Yes! There will be an exhibition segment where you get to pitch your prototypes to the judges and others!`,
      },
      {
        id: 16,
        title: 'How do we handle Intellectual Property (IP)?',
        type: 'text',
        content: `Please refer to the Terms and Conditions at the bottom of the page.`,
      },
      {
        id: 17,
        title: 'Will I get a certificate of participation for taking part?',
        type: 'text',
        content: `Apologies, but we currently do not have provisions for this.`,
      },
      {
        id: 18,
        title: 'Do I have to use a particular coding language?',
        type: 'text',
        content: `You are free to use any programming language you desire or need to use based on your prototype. 
          There are no restrictions or requirements as to using specific programming languages.`,
      },
      {
        id: 19,
        title: 'My question can’t be found in the FAQs!',
        type: 'text',
        content: `For any further queries or clarifications, feel free to drop us a message via the contact form below, or email us at sutdwth@gmail.com`,
      },
    ],
  },
];
